<template>
    <BaseDialog
        :showDialog="showDialog"
        headline="lang_ACCOUNT_MODULES_DIALOG_CAPTION_CHANGE_BOOKING"
        :close="close"
        persistent
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-dialog-text'">
                        {{ $t(dialogText) }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right">
                        <BaseButton 
                            label="lang_GENERAL_CONFIRM"
                            @click="confirm"
                            :alvqa="alvqa + '-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>


<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "ChangeModulStatusDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            alvqa: 'account-module-dialog-change-status'
        }
    },
    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowChangeModulStatusDialog },
            set(show) { this.$store.commit('setShowChangeModulStatusDialog', show) }
        },

        dialogText() { return this.$store.getters.getChangeModulStatusDialogText },
    },
    methods: {
        close() {
            let selectedModul = this.$store.getters.getSelectedModul
            selectedModul.status = !selectedModul.status

            this.$store.commit('setSelectedModul', {})
            this.showDialog = false
        },

        confirm() {
            this.$store.dispatch('saveModule')
            this.showDialog = false
        }
    }
}
</script>